import React from 'react'
import RegistrationForm from '../component/registrationForm/RegistrationForm'

export default function () {
  return (
    <div>
        <RegistrationForm/>
    </div>
  )
}
